import {ErrorMessageProps, ErrorsMessage, ErrorsType} from './ErrorsType';
import React from 'react';
import {HttpError} from '../../../../api/client';
import {ApiError} from './ErrorBoundary';
import {MessageDialog} from '../MessageDialog/MessageDialog';
import {useConfig} from '../../../utils/config';
import {getAuth} from '../../../utils/auth';
import {ButtonTypography, PrimaryContainedButton} from '../Buttons/buttons';
import {useTranslation} from 'react-i18next';

export const UnauthorizedMessage: React.FC<ErrorMessageProps> = ({open, onClose, error}) => {
  let message = '';
  const {t} = useTranslation();
  const config = useConfig();

  async function reAuthenticate() {
    const auth = await getAuth(config);
    try {
      await auth.client.signinSilent();
      onClose();
    } catch (err: any) {
      message = err.message;
    }
  }

  try {
    const apiError = (error as HttpError).data as ApiError;
    message = apiError?.message;

  }catch (ex : any){
    message = ex.message;
  }


  const buttons = (<PrimaryContainedButton
    test-id={'reauthenticate-btn'}
    onClick={reAuthenticate}
  >
    <ButtonTypography>{t('Autentisere på nytt')}</ButtonTypography>
  </PrimaryContainedButton>);
  return (
    <MessageDialog title={'En feil har oppstått'}  width={700} height={300}  open={open} onClose={onClose} buttons={buttons}>
      <div >
        <span>{ErrorsMessage[ErrorsType.Unauthorized]}</span>
        <br/>
        <span>{message}</span>
      </div>
    </MessageDialog>
  );
};
